import script from "./CollectionProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionProduct.vue?vue&type=script&setup=true&lang=js"

import "./CollectionProduct.vue?vue&type=style&index=0&id=b7e1bc7c&lang=scss"

const __exports__ = script;

export default __exports__